//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';

export default {
  name: 'product-card-more-info',
  components: {
    Price: () => import('@motionelements/core/src/components/product/ElementPrice.vue'),
    NotAvailableBadge: () => import('@motionelements/core/src/components/product-card/NotAvailableBadge.vue'),
  },
  mixins: [featureFlagMixin],
  props: {
    element: Object,
    showName: {
      type: Boolean,
      default: false,
    },
    showCategory: {
      type: Boolean,
      default: false,
    },
    showPrice: {
      type: Boolean,
      default: false,
    },
    linkUrl: String,
    isProductAvailable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    mediaType() {
      return this.element.mediaType;
    },
    mainCategory() {
      // console.log(this.element.categories);
      if (_.size(this.element.categories)) {
        let category;

        const currentCategoryId = this.$route.query.category;

        if (currentCategoryId) {
          // get different one
          category = this.element.categories.find(x => x.id !== currentCategoryId);
          if (category) {
            return category;
          }
        }

        category = this.element.categories.find(x => x.type === 'category');

        if (category) {
          return category;
        }

        return this.element.categories[0];
      }

      return null;
    },
  },
  methods: {
    onClickCategory(event) {
      // console.log('event cat', event);
      // this.$bus.$emit('view-product', this.eventData); // send event to mixins product-events
      const isSearchRepo = process.env.VUE_APP_PROJECT_NAME && process.env.VUE_APP_PROJECT_NAME === 'frontend-search';
      if (isSearchRepo) {
        // open new window: windows use ctrl key, mac use command=meta key
        // change use preventDefault to provide open tab in background function
        // https://vuejs.org/v2/guide/events.html
        // @click.exact: will only fire when no system modifiers are pressed

        // console.log('event push route', this.$link(event.target.href).fullPath());
        event.preventDefault();
        this.$router.push({
          path: this.$link(event.target.href).fullPath(),
        });
      }
    },
    viewProduct(event) {
      this.$emit('view-product', event);
    },
  },
};
